module.exports = __webpack_public_path__ + "img/2trebol.136dab43.png";